<template>
  <div class="PasswordLogin">
    <MyTab v-if="step_2.length !== 0"></MyTab>
    <!-- 信息认证 -->
    <TabInfoAuthentication
      v-show="tabActive === 1"
      :configList="step_1"
      :perfectOrderInfo="perfectOrderInfo"
      :bankName="bankName"
    />
    <!-- 资料填写 -->
    <TabSupplementInfo
      v-show="tabActive === 2"
      :configList="step_2"
      :perfectOrderInfo="perfectOrderInfo"
    />
    <!-- 弹框 -->
    <Notification
      :isShow="isShowNotif"
      :title="title"
    ></Notification>
    <CodePopup
      title="请输入验证码"
      @getInputPicVal="getInputPicVal"
      @define="define"
      @sendPicCode="sendPicCode"
      @close="close"
      :imgUrl="publicPage.imgUrl"
      :value="publicPage.isPicCodeShow"
      :isShow="publicPage.isPicCodeShow"
    ></CodePopup>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CodePopup from './components/CodePopup.vue';
import Notification from './components/common/Notification.vue';
import TabSupplementInfo from './components/tabSupplementInfo/index.vue';
import TabInfoAuthentication from './components/tabInfoAuthentication/index.vue';
import MyTab from './components/common/MyTab.vue';
import { enhanceXydContractConfig } from '@/utils/xydNoTax';

export default {
  name: 'Perfect',
  data() {
    return {
      title: '',
      isShowNotif: false,
      step_1: [], // 第一个tab页面的配置
      step_2: [], // 第二个tab页面的配置
      perfectOrderInfo: {}, // 回显的数据
      bankName: '',
      inputPicVal: '',
    };
  },
  components: {
    MyTab,
    Notification,
    TabSupplementInfo,
    TabInfoAuthentication,
    CodePopup
  },
  created() {
    this.getUserCorp();
    // 获取页面配置和回显数据
    // this.getProductionConfig();
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
    ...mapState({
      tabActive(val) {
        return val.publicPage.tabActive;
      },
    }),
  },
  // 根据认证状态判断是否有在途订单
  watch: {
    // 修改标题
    tabActive: {
      handler(n) {
        if (this.step_2.length === 0) {
          document.title = '信息确认';
          return;
        }
        if (n === 1) {
          document.title = '信息确认';
        } else {
          document.title = '信息确认';
        }
      },
      immediate: true,
    },
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['sendPicCode']),
    close() {
      console.log("---")
      this.updateState({isPicCodeShow:false})
      // this.isShow = false;
    },
    loginVerify() {
      this.$api.PublicPage.loginVerify({
        phone: this.perfectOrderInfo.borrowerPhone,
        type: "1",
        captcha: this.inputPicVal,
      }).then((res) => {
        if (!res.success) {
          this.$toast(res.returnMessage);
        }else{
          this.updateState({isPicCodeShow:false})
        }
      });
    },
    define(obj) {
      if (obj.value) {
        this.loginVerify();
      }
    },
    getInputPicVal(val) {
      this.inputPicVal = val;
    },

    // 获取配置项进件
    getProductionConfig(productId,phone) {
      this.$toast.loading({
        message: '加载中...',
        clear: true,
        forbidClick: true,
        loadingType: 'spinner',
      });
      this.$api.PublicPage.getProductConfig({
        productId
      })
        .then((res) => {
          // res = {"success":true,"returnCode":"200","returnMessage":"成功","data":[{"id":499,"productId":"SN-PED","productConfigs":"[{\"step_1\":[{\"field\":\"corpName\",\"value\":\"\",\"title\":\"企业名称\",\"focusStatus\":false,\"type\":\"SelectInputs\",\"props\":{\"type\":\"text\",\"maxLength\":50,\"placeholder\":\"请输入企业名称\"},\"validate\":[{\"required\":true,\"message\":\"请输入正确的企业名称\",\"pattern\":[\"^[\\\\u4e00-\\\\u9fa5A-Za-z0-9\\\\(\\\\)\\\\（\\\\）]{2,50}$\"]}],\"id\":0},{\"field\":\"taxNo\",\"value\":\"\",\"title\":\"企业税号\",\"focusStatus\":false,\"type\":\"Input\",\"props\":{\"type\":\"text\",\"maxLength\":20,\"placeholder\":\"请输入企业税号\"},\"validate\":[{\"required\":true,\"message\":\"请输入正确的企业税号\",\"pattern\":[\"^[0-9a-zA-Z]{15,20}$\"]}],\"id\":1},{\"field\":\"borrowerType\",\"value\":\"\",\"title\":\"申请人类型\",\"focusStatus\":false,\"type\":\"ApplicationType\",\"props\":{\"type\":\"text\",\"placeholder\":\"请输入申请人类型\"},\"validate\":[{\"required\":true,\"message\":\"请选择正确的申请人类型\",\"pattern\":[\"^\\\\S+$\"]}],\"id\":2},{\"field\":\"borrowerName\",\"value\":\"\",\"title\":\"姓名\",\"type\":\"Input\",\"focusStatus\":false,\"props\":{\"type\":\"text\",\"maxLength\":20,\"placeholder\":\"请输入姓名\"},\"validate\":[{\"required\":true,\"message\":\"请输入正确的姓名\",\"pattern\":[\"^[\\\\u4e00-\\\\u9fa5]{2,20}$\"]}],\"id\":3},{\"field\":\"borrowerIdentity\",\"value\":\"\",\"title\":\"身份证号\",\"type\":\"Input\",\"props\":{\"type\":\"text\",\"maxLength\":18,\"placeholder\":\"请输入身份证号\"},\"validate\":[{\"required\":true,\"message\":\"身份证格式错误\",\"pattern\":[\"(^\\\\d{18}$)|(^\\\\d{17}(\\\\d|X|x)$)\"]}],\"id\":4},{\"field\":\"borrowerPhone\",\"value\":\"\",\"title\":\"手机号\",\"type\":\"Input\",\"focusStatus\":false,\"props\":{\"type\":\"text\",\"maxLength\":11,\"disabled\":true,\"placeholder\":\"请输入手机号\"},\"validate\":[{\"required\":true,\"message\":\"请输入正确手机号\",\"pattern\":[\"^1\\\\d{10}$\"]}],\"id\":5},{\"field\":\"referrer\",\"value\":\"\",\"title\":\"邀请码\",\"type\":\"VerificationCode\",\"focusStatus\":false,\"props\":{\"type\":\"text\",\"maxLength\":6,\"placeholder\":\"请联系客户经理索要邀请码\"},\"validate\":[{\"required\":true,\"message\":\"请输入6位数字的邀请码\",\"pattern\":[\"^\\\\d{6}$\"]}],\"id\":6},{\"field\":\"Contract\",\"value\":false,\"title\":\"\",\"type\":\"Contract\",\"props\":{\"type\":\"string\",\"text\":\"本人已阅读并完全同意\",\"defaultCheck\":false,\"list\":[{\"text\":\"授权承诺书\",\"value\":\"bw_sq\"}]},\"validate\":[]},{\"field\":\"button\",\"value\":\"\",\"title\":\"下一步\",\"type\":\"NextButton\",\"props\":{},\"validate\":[]}],\"step_2\":[{\"field\":\"loanAmount\",\"value\":\"\",\"title\":\"借款金额\",\"focusStatus\":false,\"type\":\"LoanAmountInput\",\"props\":{\"type\":\"text\",\"min\":1,\"max\":200,\"placeholder\":\"1-200\"},\"validate\":[{\"required\":true,\"message\":\"请输入正确的借款金额\",\"pattern\":[\"^\\\\S+$\"]}],\"id\":8},{\"field\":\"termLoan\",\"value\":\"\",\"title\":\"借款期限\",\"type\":\"BWSelect\",\"props\":{\"type\":\"text\",\"placeholder\":\"请选择借款期限\",\"columnsTerm\":[{\"text\":\"6个月\",\"value\":\"6\"},{\"text\":\"12个月\",\"value\":\"12\"},{\"text\":\"18个月\",\"value\":\"18\"}]},\"validate\":[{\"required\":true,\"message\":\"请选择借款期限\",\"pattern\":[\"^\\\\S+$\"]}],\"id\":9},{\"field\":\"Button\",\"value\":true,\"title\":\"\",\"type\":\"PlaceOrderButton\",\"isShowReturnBtn\":true,\"props\":{\"type\":\"string\",\"text\":\"提交\"},\"validate\":[{\"required\":true,\"message\":\"\",\"pattern\":{}}]}]}]","updateTime":"2023-10-12 19:39:39","status":1,"productName":"苏宁银行-发票贷plus","isShowOrgDoc":0,"showOrgName":"苏宁银行"}]};
          if (res.success) {
            const result = JSON.parse(res.data[0].productConfigs);
            // eslint-disable-next-line camelcase
            const t1 = result[0].step_1.map((item) => {
              return { ...item, props: { ...item.props, disabled: true } };
            });
            // 查找Contract项的索引
            const contractIndex = t1.findIndex(item => item.field === 'Contract');
            // 如果找到Contract项，则在其前面插入验证码项，否则保持原数组不变
            const step_1 = contractIndex !== -1
              ? [
                  ...t1.slice(0, contractIndex),
                  {
                    "field": "captcha",
                    "value": "",
                    "title": "验证码",
                    "type": "MessageCode",
                    "focusStatus": false,
                    "props": {
                      "type": "text",
                      "maxLength": 6,
                      "placeholder": "请输入验证码"
                    },
                    phone,
                    "validate": [
                      {
                        "required": true,
                        "message": "请输入6位数字的验证码",
                        "pattern": ["^\\d{6}$"]
                      }
                    ],
                    "id": 7
                  },
                  ...t1.slice(contractIndex)
                ]
              : [...t1] || [];
            // eslint-disable-next-line camelcase
			      const step_2 = result[0].step_2 || [];
            // 给字段增加函数校验
            const Index = step_1.findIndex((e) => e.type === 'SelectInputs');
            const Index2 = step_2.findIndex((e) => e.type === 'SelectInputs');
            const haierIndex = step_1.some((e) => e.isShow === true);
            this.updateState({
              haierIndex,
            });
            if (Index === -1 && Index2 === -1) {
              this.updateState({
                isShowCorpName: true,
              });
            }
            this.step_1 = step_1.map((item, index) => {
              item = enhanceXydContractConfig(item, productId);
              if (item.type === 'Contract') {
                item.props.list = [
                  ...item.props.list,
                  {
                    text: '用户服务协议',
                    value: 'REGISTERAGREEMENT',
                  },
                  {
                    text: '隐私政策',
                    value: 'Privacypolicy',
                  }
                ];
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'ContractFold') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'ApplicationType') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      const flag = value * 1 <= 2;
                      return !!flag;
                    },
                  },
                  ],
                };
              }
              return item;
            });
            this.step_2 = step_2.map((item) => {
              if (item.type === 'Contract') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'ContractFold') {
                return {
                  ...item,
                  validate: [{
                    validator(rule, value) {
                      return value;
                    },
                  },
                  ],
                };
              }
              if (item.type === 'LoanAmountInput') {
                return {
                  ...item,
                  validate: [
                    {
                      validator(rule, value) {
                        if (Number(value) >= Number(item.props.min) && Number(value) <= Number(item.props.max)) {
                          return true;
                        }
                        return false;
                      },
                      message: `${item.props.min}-${item.props.max}(万元)正整数`,
                    },
                  ],
                };
              }
              if (productId === 'YL-YPD' && item.field === 'iceContactPhone'||(productId === 'BW-BSD' && (item.field === 'iceContactPhone'||item.field === 'iceContactPhone2'))) { // 亿联控制紧急联系人手机号不能与申请人手机号一致
                const applyPhone = sessionStorage.getItem('APPLE_PHONE');
                return {
                  ...item,
                  ...item.validate.push({
                    message: '借款人手机号不能与联系人手机号一致',
                    pattern: [new RegExp(`^(?!${applyPhone})`)],
                  }),
                };
              }
              return item;
            });
          }
          // this.getUserCorp();
        })
        .finally(() => {
          this.$toast.clear();
        });
    },
    getUserCorp() {
      this.$api.PublicPage.queryForeignOrderShow({
        foreignOrderId: this.$route.query.foreignOrderId,
      }).then((res) => {
        if (res.success) {
          const { data } = res;
          sessionStorage.setItem('APPLE_PHONE', data.applyPhone);
          this.perfectOrderInfo = {
            ...res.data,
            borrowerType: data.applyType,
            borrowerIdentity: data.applyId,
            borrowerPhone: data.applyPhone,
            borrowerName: data.applyName,
          };

          // 获取该产品所属服务银行名称
          this.getBankNameByProduct(data.productId);
          // 获取配置项进件
          this.getProductionConfig(data.productId,data.applyPhone)
          this.updateState({
            submitInfoAll: {
              corpId: '', // 默认清空 corpId
              ...this.publicPage.submitInfoAll,
              ...res.data,
            },
          });
        }
      });
    },
    // 获取该产品所属服务银行名称
    getBankNameByProduct(productId) {
      this.$api.PublicPage.getBankNameByProduct({
        productId
      }).then((res) => {
        this.bankName = res.data.showOrgName;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.PasswordLogin {
  >>> .agreement {
    margin-top: 6px;
  }

}

</style>
